import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ParticipantThemeService } from 'src/app/services/participant-theme.service';
import { TranslationService } from 'src/app/services/translation.service';
import { NeedHelpService } from 'src/app/services/need-help.service';
import { UserProfile, UserProfileDefaultValues } from '../../users/userdetail';
import { Provinces } from '../../global/province';
import { AuthService } from 'src/app/services/auth.service';
import { ApplicationRoles } from '../../users/user-roles';

@Component({
    selector: 'app-need-help',
    templateUrl: './need-help.component.html',
    styleUrls: ['./need-help.component.scss'],
    standalone: false
})
export class NeedHelpComponent implements OnInit {
  translations: any;
  participantClassByRole: string = '';
  userProfile: UserProfile = UserProfileDefaultValues();
  isUserInBC: boolean = false;
  isUserInOntario: boolean = false;
  isUserInQuebec: boolean = false;  
  isUserInManitoba:boolean=false;
  isUserInNewBrunswick:boolean=false;
  isUserInOther: boolean = false;

  isUserCoached:boolean=false
  isUserSelfGuided:boolean=false;

  constructor(public dialogRef: MatDialogRef<NeedHelpComponent>,
    private translationservice: TranslationService,
    private themeService: ParticipantThemeService,
    private authService: AuthService,
    private needHelpService: NeedHelpService)
  { }

  getTelLink(contentKey: string): string | null {
    return this.needHelpService.getTelLink(this.translations?.[contentKey]);
  }

  ngOnInit(): void {
    this.translationservice.getTranslation().subscribe((data: any) => {
      this.translations = data;
    });

    this.themeService.setParticipantTheme();
    this.participantClassByRole = this.themeService.participantClassByRole;

    let province = this.authService.getUserLoginData().provinceId as Provinces
    this.isUserInBC = province == Provinces.BritishColumbia;
    this.isUserInManitoba = province == Provinces.Manitoba;
    this.isUserInNewBrunswick = province == Provinces.NewBrunswick; 
    this.isUserInOntario = province == Provinces.Ontario;
    this.isUserInQuebec = province == Provinces.Quebec;
    this.isUserInOther = !this.isUserInBC && !this.isUserInManitoba && !this.isUserInOntario && !this.isUserInNewBrunswick && !this.isUserInQuebec

    let userRole = this.authService.getAccessControl().participantLastActiveRole as ApplicationRoles

    this.isUserCoached = userRole == ApplicationRoles.BB_CoachedParticipant
    this.isUserSelfGuided = userRole == ApplicationRoles.BB_SelfGuidedParticipant
  }

  onCloseClick() {
    this.dialogRef.close();
  }
}
